<template>
  <div class="login-container">
    <div class="center">
      <img :src="loginPic ? baseUrl + loginPic : require('../../assets/login_pic.jpg')" alt="">
      <el-form :model="form" :rules="rules" ref="form">
        <img :src="baseUrl + logo" alt="" v-if="logo">
        <el-form-item prop="userName">
          <el-input v-model="form.userName" prefix-icon="el-icon-user" placeholder="请输入用户名"
            @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" show-password prefix-icon="el-icon-lock" placeholder="请输入密码"
            @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-button type="primary" @click="login">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api'
export default {
  name: 'Login',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      loginPic: '',
      logo: '',
      form: {
        userName: '',
        password: '',
        platformType: 1
      },
      rules: {
        userName: [{ required: true, trigger: 'change', message: '用户名不能为空' }],
        password: [{ required: true, trigger: 'change', message: '密码不能为空' }]
      },
      redirect: ''
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async created() {
    // baseUrl
    const { data: { settingValue } } = await api.getConfigInfo('minio_baseUrl')
    this.baseUrl = settingValue
    localStorage.setItem('baseUrl', settingValue)
    // 背景图
    const { data: { settingValue: loginBg } } = await api.getConfigInfo('login_bg')
    if (loginBg) {
      const dom = document.querySelector('.login-container')
      dom.style.backgroundImage = `url(${this.baseUrl}${loginBg})`
    }
    // 宣传图
    const { data: { settingValue: loginPic } } = await api.getConfigInfo('login_pic')
    this.loginPic = loginPic
    // logo
    const { data: { settingValue: logo } } = await api.getConfigInfo('system_logo')
    this.logo = logo
    localStorage.setItem('logo', logo)
  },
  methods: {
    login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { data: { token, expireTime } } = await api.login(this.form)
          this.redirect = this.$route.query.redirect_url
          if (this.redirect) {
            window.location.href = `${decodeURIComponent(this.redirect)}&token=${token}&expireTime=${expireTime}`
          } else {
            localStorage.setItem('sys_token', token)
            localStorage.setItem('expireTime', expireTime)
            this.$router.push('/home')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(../../assets/login_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .center {
    width: 850px;
    aspect-ratio: 2;
    display: flex;
    background: #fff;

    img {
      width: 50%;
      height: 100%;
    }

    .el-form {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 15px;

      img {
        height: 40px;
        width: fit-content;
        margin-bottom: 30px;
      }

      ::v-deep.el-input__inner {
        width: 300px;
        border-radius: 0;
      }

      .el-button {
        width: 300px;
        border-radius: 0;
      }
    }
  }
}
</style>
